import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import { CARD_GAME_CURRENCY } from "@/store/apis/balanceAPI"
import { BalancePill } from "@/ui/BalancePill"
import { Button } from "@/ui/Button"
import styles from "./Quests.module.scss"
import { QUESTS_TABS } from "./values"

export const Quests: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className={styles.Quests}>
      <div className={styles.Quests_title}>{t("quests.title")}</div>
      <div className={styles.Quests_inner}>
        <div className={styles.Quests_content}>
          <div className={styles.Quests_content_header}>
            <div className={styles.Quests_nav}>
              <Button.Back link={ROUTES.HOME} />
              <BalancePill currency={CARD_GAME_CURRENCY.GOLDEN_DUST} />
            </div>
            <div className={styles.Quests_content_switcher} role="tablist">
              {QUESTS_TABS.map(({ segment, label, path }) => (
                <button
                  key={segment}
                  type="button"
                  role="tab"
                  aria-selected={location.pathname === path}
                  className={clsx(styles.Quests_content_switcher_item, {
                    [styles.active]: location.pathname === path
                  })}
                  onClick={() => navigate(path)}
                >
                  {t(label)}
                </button>
              ))}
            </div>
          </div>
          <div className={styles.Quests_content_body}>
            <Routes>
              <Route index element={<Navigate to="quests" replace />} />
              {QUESTS_TABS.map(({ segment, Component }) => (
                <Route key={segment} path={segment} element={<Component />} />
              ))}
            </Routes>
          </div>
        </div>
      </div>
    </div>
  )
}
